'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

var useDocument = function () {
    var _a = React.useState(), domDocument = _a[0], setDomDocument = _a[1];
    React.useEffect(function () {
        if (typeof window !== 'undefined') {
            setDomDocument(document);
        }
    }, []);
    return domDocument;
};

exports["default"] = useDocument;
//# sourceMappingURL=useDocument.js.map
